module.exports = __webpack_public_path__ + "static/media/vipIcon.7798787b.png";